import { useQuery } from '@tanstack/vue-query'
import Organisation from '@/api/Dara/Organisation'
import { organisationKeys } from '@/composable/queries/keys'

export const useYearsAndSubgroupsQuery = (
  organisationId: Ref<number>,
  enabled: Ref<boolean> = ref(true),
) => {
  return useQuery({
    queryKey: organisationKeys.groups(organisationId),
    queryFn: () => Organisation.getYearsAndSubgroups(organisationId.value),
    enabled
  })
}
